import { Languages, Linkedin, Twitter, Facebook, Instagram, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Platform",
    links: [
      { label: "Solutions", href: "/#services" },
      { label: "Industries", href: "/#industries" },
      { label: "Languages", href: "/#languages" },
      { label: "How It Works", href: "/#how-it-works" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/#why-us" },
      { label: "Contact", href: "/contact" },
      { label: "FAQ", href: "/legal/faq" },
      { label: "Get a Quote", href: "/#quote" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/legal/privacy" },
      { label: "Terms & Conditions", href: "/legal/terms" },
      { label: "Cookie Policy", href: "/legal/cookies" },
    ],
  },
  {
    title: "Popular",
    links: [
      { label: "English → Arabic", href: "/languages/english-to-arabic-translation" },
      { label: "English → French", href: "/languages/english-to-french-translation" },
      { label: "English → German", href: "/languages/english-to-german-translation" },
      { label: "Cosmetics Translation", href: "/industries/cosmetics-translation-services" },
      { label: "Certified Translation", href: "/industries/certified-translation-services" },
    ],
  },
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#070B14] text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-9 h-9 rounded-lg bg-[#C87A4B] text-white flex items-center justify-center">
                <Languages className="w-5 h-5" strokeWidth={1.8} />
              </span>
              <span className="font-heading font-bold text-xl tracking-tight text-white">
                Translate<span className="text-[#C87A4B]">It</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              Professional translation and localisation for businesses and individuals across global markets.
              Secure, confidential and quality reviewed.
            </p>
            <div className="flex flex-col gap-2.5 mt-6 text-sm text-slate-400">
              <span className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-[#C87A4B]" /> hello@translateit.website</span>
              <span className="flex items-center gap-2.5"><MapPin className="w-4 h-4 text-[#C87A4B]" /> London, United Kingdom</span>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[Linkedin, Twitter, Facebook, Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-icon-${i}`}
                  aria-label="Social link"
                  className="w-9 h-9 rounded-lg border border-slate-700 flex items-center justify-center text-slate-400 hover:text-white hover:border-[#C87A4B] transition-colors duration-200"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-5">{col.title}</p>
              <ul className="flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} TranslateIt. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-slate-600 hover:text-slate-400 transition-colors">
            Team Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
